import { Controller, useFormContext } from 'react-hook-form';
// Deep import on purpose: the slice barrel also re-exports the workout
// curation UI, and pulling that into the program form's module graph pushes
// its specs past their 20s budget under full-suite load.
import { ProgramSwapsToggle } from '@client/new/features/exercise-swaps/ui/ProgramSwapsToggle';
import { ProgramFormValues } from '../model/programForm.types';

type ProgramSwapsFieldProps = {
  creatorId: number;
  programId: number;
  isSubmitting?: boolean;
};

export const ProgramSwapsField = ({
  creatorId,
  programId,
  isSubmitting,
}: ProgramSwapsFieldProps) => {
  const { control } = useFormContext<ProgramFormValues>();
  return (
    <Controller
      control={control}
      name="swapsEnabled"
      render={({ field }) => (
        <ProgramSwapsToggle
          influencerId={creatorId}
          programId={programId}
          value={field.value}
          onChange={field.onChange}
          disabled={isSubmitting}
        />
      )}
    />
  );
};
